import * as React from 'react';

import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import type { InjectedRouter } from 'js/lib/connectToRouter';
import waitForGraphQL from 'js/lib/waitForGraphQL';

import type {
  EnterpriseProgramBySlugQueryResult,
  EnterpriseProgramBySlugQueryVariables,
} from 'bundles/enterprise-legacy-learner-home/queries/EnterpriseProgramBySlugQuery';
import EnterpriseProgramBySlugQuery from 'bundles/enterprise-legacy-learner-home/queries/EnterpriseProgramBySlugQuery';
import { branchBypassLogin } from 'bundles/program-home/components/ProgramHomeApp';
import type { Stores } from 'bundles/unified-career-academy/appEnv';
import UnifiedAppCheckProvider from 'bundles/unified-common/providers/UnifiedAppCheckProvider';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-career-academy/__styles__/index';

type Props = {
  requestCountryCode?: string | null;
  csrfToken?: string | null;
};
type PropsFromRouter = {
  router: InjectedRouter;
  programSlug: string;
};
type PropsForWithEnterpriseProgramData = Pick<PropsFromRouter, 'programSlug'>;
type PropsFromWithEnterpriseProgramData = { thirdPartyOrganizationId?: string };
const UnifiedCareerAcademyApp: React.LegacyFunctionComponentWithChildren<Props> = ({ children }) => {
  return (
    <div className="rc-UnifiedCareerAcademyApp">
      <UnifiedAppCheckProvider>{children}</UnifiedAppCheckProvider>
    </div>
  );
};

export default compose<{}, React.PropsWithChildren<{}>>(
  connectToStores<Props, {}, Stores>(['ApplicationStore'], ({ ApplicationStore }, props) => ({
    ...props,
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  })),
  connectToRouter<PropsFromRouter, {}>((router): PropsFromRouter => {
    return {
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      programSlug: router.params.programSlug,
      router,
    };
  }),
  withMarketingConsent,
  waitForGraphQL<
    PropsForWithEnterpriseProgramData,
    EnterpriseProgramBySlugQueryResult,
    EnterpriseProgramBySlugQueryVariables,
    PropsFromWithEnterpriseProgramData
  >(EnterpriseProgramBySlugQuery, {
    options: ({ programSlug }) => ({ variables: { programSlug } }),
    props: ({ data }) => {
      return {
        // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        thirdPartyOrganizationId: data?.EnterpriseProgramsV1?.slug?.elements?.[0].thirdPartyOrganizationId,
      };
    },
  }),
  branchBypassLogin
)(UnifiedCareerAcademyApp);
